import { render } from "./UsadosBanner.vue?vue&type=template&id=6440c90c"
import script from "./UsadosBanner.vue?vue&type=script&lang=js"
export * from "./UsadosBanner.vue?vue&type=script&lang=js"

import "./UsadosBanner.vue?vue&type=style&index=0&id=6440c90c&lang=scss"

import exportComponent from "/home/rubb/NiwCaetano/Frontend/governance/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__